import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import MarketingModal from './MarketingModal';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import * as styles from './styles/styles.module.scss';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useLanguageCode from 'hooks/useLanguageCode';

const {
  strings: { TAKE_YOUR_ALLTRAILS, TRY_THE_ALLTRAILS_APP, GET_MORE_FROM }
} = StringConstantsMixin;

function Picture() {
  const languageCode = useLanguageCode();
  // I think this is better than writing a bunch of import statements
  /* eslint-disable global-require, import/no-dynamic-require */
  const jpg = require(`./appinstall-${languageCode}.jpg`).default;
  const avif = require(`./appinstall-${languageCode}.avif`).default;
  const avif2x = require(`./appinstall-${languageCode}-2x.avif`).default;
  const avif3x = require(`./appinstall-${languageCode}-3x.avif`).default;
  /* eslint-enable global-require, import/no-dynamic-require */

  return (
    <picture>
      <source srcSet={avif} type="image/avif" />
      <source srcSet={`${avif2x} 2x`} type="image/avif" />
      <source srcSet={`${avif3x} 3x`} type="image/avif" />
      <img className={styles.img} src={jpg} />
    </picture>
  );
}

function AppInstallModal() {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <MarketingModal
      color="white"
      headerText={TAKE_YOUR_ALLTRAILS}
      instructionsText={languageRegionCode === LanguageRegionCode.English ? TRY_THE_ALLTRAILS_APP : GET_MORE_FROM}
      picture={<Picture />}
    />
  );
}

export default AppInstallModal;
